import React from 'react';

import { CaptionText } from '@make-software/cspr-design';

import { ContentWrapperBottom, FooterBottomBar } from './styled';

export const PageFooter: React.FC = () => {
  return (
    <ContentWrapperBottom>
      <FooterBottomBar>
          <CaptionText variation="darkGray" size={2}>
            © 2025 ChainMail
          </CaptionText>
      </FooterBottomBar>
    </ContentWrapperBottom>
  );
};
